
export class CourseCategory {
    constructor(cc) {
        this.id = cc.id
        this.name = cc.name
        if (cc.sons instanceof Array) {
            this.sons = cc.sons.map(s => {
                return new CourseCategory(s)
            })
        } else {
            this.sons = []
        }
    }
    subCategories() {
        return this.sons.map(s => {
            return {
                id: s.id,
                name: s.name
            }
        })
    }
}
